import { superAdminApi } from "../authService";
import {
  ApiResponse,
  PaginatedApiResponse,
  PaginationParams,
} from "../../types/api";
import { PlanCurrency } from "../planService";

const RESOURCE = "/super-admin/promotion-coupons";

export type CouponDurationType = "first_month" | "limited_months" | "lifetime";

export interface SaasPromotionCoupon {
  id: number;
  code: string;
  name: string;
  discount_percent_bps: number;
  duration_type: CouponDurationType;
  duration_months: number | null;
  max_redemptions: number;
  redemption_count: number;
  redemptions_remaining: number;
  valid_from: string;
  valid_until: string;
  applicable_plan_ids: number[] | null;
  applicable_currencies: PlanCurrency[];
  partner_id: number | null;
  allow_on_upgrade: boolean;
  is_active: boolean;
  created_by_super_admin_id: number | null;
  applications_count?: number;
  created_at: string;
  updated_at: string;
}

export interface CreateSaasPromotionCouponPayload {
  code: string;
  name: string;
  discount_percent_bps: number;
  duration_type: CouponDurationType;
  duration_months?: number | null;
  max_redemptions: number;
  valid_from: string;
  valid_until: string;
  applicable_plan_ids?: number[] | null;
  applicable_currencies: PlanCurrency[];
  partner_id?: number | null;
  allow_on_upgrade?: boolean;
  is_active?: boolean;
}

export type UpdateSaasPromotionCouponPayload = Partial<CreateSaasPromotionCouponPayload>;

export interface SaasPromotionCouponListParams extends PaginationParams {
  search?: string;
  is_active?: boolean;
  partner_id?: number;
}

export const getPromotionCoupons = async (
  params?: SaasPromotionCouponListParams
): Promise<PaginatedApiResponse<SaasPromotionCoupon>> => {
  const response = await superAdminApi.get<PaginatedApiResponse<SaasPromotionCoupon>>(
    RESOURCE,
    { params }
  );

  return response.data;
};

export const getPromotionCoupon = async (
  id: number
): Promise<ApiResponse<SaasPromotionCoupon>> => {
  const response = await superAdminApi.get<ApiResponse<SaasPromotionCoupon>>(
    `${RESOURCE}/${id}`
  );

  return response.data;
};

export const createPromotionCoupon = async (
  payload: CreateSaasPromotionCouponPayload
): Promise<ApiResponse<SaasPromotionCoupon>> => {
  const response = await superAdminApi.post<ApiResponse<SaasPromotionCoupon>>(
    RESOURCE,
    payload
  );

  return response.data;
};

export const updatePromotionCoupon = async (
  id: number,
  payload: UpdateSaasPromotionCouponPayload
): Promise<ApiResponse<SaasPromotionCoupon>> => {
  const response = await superAdminApi.patch<ApiResponse<SaasPromotionCoupon>>(
    `${RESOURCE}/${id}`,
    payload
  );

  return response.data;
};

export const deactivatePromotionCoupon = async (
  id: number
): Promise<ApiResponse<SaasPromotionCoupon>> => {
  const response = await superAdminApi.patch<ApiResponse<SaasPromotionCoupon>>(
    `${RESOURCE}/${id}/deactivate`
  );

  return response.data;
};
